import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemStock\UpdateLocationToItemStockController::__invoke
* @see app/Http/Controllers/ItemStock/UpdateLocationToItemStockController.php
* @route '/api/stock/item-stock/{item_stock}/set-location'
*/
const UpdateLocationToItemStockController = (args: { item_stock: string | number | { id: string | number } } | [item_stock: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateLocationToItemStockController.url(args, options),
    method: 'put',
})

UpdateLocationToItemStockController.definition = {
    methods: ["put"],
    url: '/api/stock/item-stock/{item_stock}/set-location',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ItemStock\UpdateLocationToItemStockController::__invoke
* @see app/Http/Controllers/ItemStock/UpdateLocationToItemStockController.php
* @route '/api/stock/item-stock/{item_stock}/set-location'
*/
UpdateLocationToItemStockController.url = (args: { item_stock: string | number | { id: string | number } } | [item_stock: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item_stock: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item_stock: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item_stock: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item_stock: typeof args.item_stock === 'object'
        ? args.item_stock.id
        : args.item_stock,
    }

    return UpdateLocationToItemStockController.definition.url
            .replace('{item_stock}', parsedArgs.item_stock.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemStock\UpdateLocationToItemStockController::__invoke
* @see app/Http/Controllers/ItemStock/UpdateLocationToItemStockController.php
* @route '/api/stock/item-stock/{item_stock}/set-location'
*/
UpdateLocationToItemStockController.put = (args: { item_stock: string | number | { id: string | number } } | [item_stock: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateLocationToItemStockController.url(args, options),
    method: 'put',
})

export default UpdateLocationToItemStockController